require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/fn/object/keys.js
// module id = 301
// module chunks = 3